// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changePasswordStyles } from "@sc/Overrides/Widgets/ChangePassword/ChangePassword";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

changePasswordStyles.passwordGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        flex-direction: column;
    `,
};

changePasswordStyles.passwordRequirementsGridItem = {
    width: [12, 12, 12, 7, 7],

    css: css`
        flex-direction: column;
        &&& {
            margin-top: 20px;
            ${xScreen("lt", "md")} {
                margin-top: 10px;
            }
        }
    `,
};

changePasswordStyles.passwordGridContainer = {
    gap: 100,
    css: css`
        margin-top: 20px;
    `,
};

changePasswordStyles.userInformationTitle = {
    variant: "h5",
    as: "h2",
};

changePasswordStyles.passwordGridItemContainer = {
    gap: 20,
    css: css`
        &&& {
            max-width: 450px;
        }
    `,
};

changePasswordStyles.actionsWrapper = {
    css: css`
        margin-top: 25px;
        ${xScreen("lt", "md")} {
            margin-top: 5px;
        }
    `,
};
